import {pageInfo, initPage,exportData,selectOrderNoList,selectPackerNameList,selectSkuList,selectItrCodeList,selectPackerCodeList,selectThirdCustomerNameList,selectRfidList} from './../api';
const boxReportForm = {
  namespaced: true,
  state: {
    total:0,
    pageResp:null,
    addResp: null,
    editResp: null,
    initPageObj: null,
    initUpdateObj: null,
    deleteResp: null,
    regionCodeObj:null,
    exportObj: null,
    orderNoListResp:null,
    packerNameListResp:null,
    skuListResp:null,
    itrCodeListResp:null,
    packerCodeListResp:null,
    thirdCustomerNameListResp:null,
    rfidListResp:null,
  },
  mutations: {

    PAGE_INFO(state,data){
      state.total = data.total;
      state.pageResp = data.obj || [];
    },
    INIT_PAGE(state,data) {
      state.initPageObj = data.obj || {};
    },
    //导出
    EXPORT_DATA(state, data) {
      state.exportObj = data;
    },
    ORDER_NO_LIST(state, data) {
      state.orderNoListResp = data
    },
    PACKER_NAME_LIST(state, data) {
      state.packerNameListResp = data
    },
    SKU_LIST(state, data) {
      state.skuListResp = data
    },
    ITR_CODE_LIST(state, data) {
      state.itrCodeListResp = data
    },
    PACKER_CODE_LIST(state, data) {
      state.packerCodeListResp = data
    },
    THIRD_CUSTOMER_NAME_LIST(state, data) {
      state.thirdCustomerNameListResp = data
    },
    RFID_LIST(state, data) {
      state.rfidListResp = data
    },

  },
  actions: {
    //查询事件
    async pageInfo({commit}, obj){
      let resp = await pageInfo(obj);
      commit('PAGE_INFO', resp);
    },
    //初始化页面事件
    async initPage({commit}, obj){
      let resp = await initPage(obj);
      commit('INIT_PAGE', resp);
    },
    //导出数据
    async exportData({ commit }, obj) {
      let resp = await exportData(obj);
      commit('EXPORT_DATA', resp);
    },
    async selectOrderNoList({ commit }, obj) {
      let resp = await selectOrderNoList(obj);
      commit('ORDER_NO_LIST', resp);
    },
    async selectPackerNameList({ commit }, obj) {
      let resp = await selectPackerNameList(obj);
      commit('PACKER_NAME_LIST', resp);
    },
    async selectSkuList({ commit }, obj) {
      let resp = await selectSkuList(obj);
      commit('SKU_LIST', resp);
    },
    async selectItrCodeList({ commit }, obj) {
      let resp = await selectItrCodeList(obj);
      commit('ITR_CODE_LIST', resp);
    },
    async selectPackerCodeList({ commit }, obj) {
      let resp = await selectPackerCodeList(obj);
      commit('PACKER_CODE_LIST', resp);
    },
    async selectThirdCustomerNameList({ commit }, obj) {
      let resp = await selectThirdCustomerNameList(obj);
      commit('THIRD_CUSTOMER_NAME_LIST', resp);
    },
    async selectRfidList({ commit }, obj) {
      let resp = await selectRfidList(obj);
      commit('RFID_LIST', resp);
    },
  }
}
export default boxReportForm



// WEBPACK FOOTER //
// ./src/page/report/boxReportForm/store/boxReportForm.store.js